import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {AutenticacionService} from './autenticacion.service';
import {HttpClient} from '@angular/common/http';
import {AppSettings} from '../../proyect.conf';
import {ProductoTipoInteres} from '../_models/producto-tipo-interes';

@Injectable({
  providedIn: 'root'
})
export class ProductoTipoInteresService {
  private rutServicio: string = AppSettings.rutServiciosAPL + "/api/productosTiposIntereses";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getByIdProducto(id: string): Observable<ProductoTipoInteres[]> {
    return this.httpClient.get<ProductoTipoInteres[]>(`${this.rutServicio}/producto/${id}`);
  }

  bulk(registros: ProductoTipoInteres[]): Observable<ProductoTipoInteres[]> {
    registros.forEach((e: ProductoTipoInteres) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoTipoInteres[]>(`${this.rutServicio}/bulk`, registros);
  }
}
